export default __webpack_public_path__ + "static/media/pic (10).9428182f.jpg";